import { Middleware } from 'openapi-fetch';

export const auth = (token?: string): Middleware => {
    return {
        onRequest: ({ request }) => {
            // add Authorization header to request
            request.headers.set('Authorization', `Bearer ${token}`);
            return request;
        },
    };
};
